<script setup>
import { useVideoCallState } from "@/stores/videoCallState";
import { Actions, EventManager, Events } from "@events";
import CommonConditions from "@lib/commonConditions";
import { ref } from "vue";

const props = defineProps({
  rtcId: {
    type: String,
    required: true,
  },
});

const actionEmitter = EventManager.getActionEmitter(props.rtcId);
const eventEmitter = EventManager.getEventEmitter(props.rtcId);

var callState = useVideoCallState(props.rtcId);

/**
 *
 * AGENT SIDE
 *
 */

// this event is emitted when the call is about to be transferred
// outcome will be different based on the type of transfer
actionEmitter.on("hold-for-transfer", (data) => {
  console.warn("Transfer action, hold-for-transfer", data);
  modalText.value = "TransferHoldAgent";
  showModal.value = true;
  /*
    available types = AgentDirect, AgentQueue, Queue
    AgentDirect is from agent to agent transfer using genesys transfer
    AgentQueue is from agent to a the desired queue, the target agent might not be available redirect to call waiting screen
    Queue is from agent to a queue, the target agent will be the first available agent in the queue, redirect to call waiting screen
  */
  if (data.type == "AgentDirect") {
    actionEmitter.emit(Actions.SendTextChannelMessage, {
      message: "TRANSFER_HOLD_START|" + data.rtcId + "|DIRECT",
    });
  } else if (data.type == "PlaceInQueue") {
    actionEmitter.emit(Actions.SendTextChannelMessage, {
      message: "TRANSFER_HOLD_START|" + data.rtcId + "|QUEUE",
    });
  }
});

actionEmitter.on("end-hold-for-transfer", (data) => {
  console.warn("Transfer action, end-hold-for-transfer", data);
  showModal.value = false;

  actionEmitter.emit(Actions.SendTextChannelMessage, {
    message: "TRANSFER_HOLD_END",
  });
});

function agentDisableTransfer() {
  actionEmitter.emit(Actions.SendTextChannelMessage, {
    message: "TRANSFER_HOLD_END",
  });

  showModal.value = false;
}

/**
 *
 * USER SIDE
 *
 */

var transferToRtcId = ref("");

eventEmitter.on(Events.TextChannelMessageReceived, async ({ data }) => {
  var parts = data.split("|");
  var action = parts[0];

  if (action == "TRANSFER_HOLD_START") {
    var rtcId = parts[1];
    var param = parts[2];

    transferToRtcId.value = rtcId;

    console.warn("Transfer message received", data);
    console.warn("Setting prevent page close to true");

    modalText.value = "TransferHoldUser";
    showModal.value = true;

    callState.setPreventPageClose(true);
    eventEmitter.on(Events.VideoCallEnded, onHangupQueue);
  } else if (action == "TRANSFER_HOLD_END") {
    console.warn("Transfer message received", data);
    console.warn("Setting prevent page close to false");

    showModal.value = false;
    callState.setPreventPageClose(false);
    eventEmitter.off(Events.VideoCallEnded, onHangupQueue);
  }
});

function onHangupQueue() {
  eventEmitter.off(Events.VideoCallEnded, onHangupQueue);
  console.warn("Hangup event received, redirecting to queue for new call");

  const customQueuePage = window.CONFIG?.CUSTOM_QUEUE_PAGE || "/";

  var newCallUrl = customQueuePage;
  // add current query params to the new call url
  var currentUrl = new URL(window.location.href);
  var newUrl = new URL(newCallUrl, window.location.origin);
  currentUrl.searchParams.forEach((value, key) => {
    newUrl.searchParams.set(key, value);
  });

  newUrl.searchParams.set("rtcId", transferToRtcId.value);
  newUrl.searchParams.set("queue", "1");

  window.location.href = newUrl.href;
}

const modalText = ref("");
const showModal = ref(false);
const isAgent = ref(CommonConditions.isAgent());
</script>

<template>
  <v-row justify="center">
    <v-dialog v-model="showModal" persistent width="500">
      <v-card>
        <v-card-title style="text-align: center">
          {{ $t("PleaseWait") }}
        </v-card-title>

        <v-card-text style="text-align: center">
          <p>{{ $t(modalText) }}</p>
          <small> {{ $t(modalText + "Detail") }}</small>
        </v-card-text>

        <v-card-actions v-if="isAgent" style="justify-content: center">
          <v-btn variant="tonal" block color="primary" @click="agentDisableTransfer">
            {{ $t("Cancel") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
